import styled from 'styled-components'
import { Media, mbSize } from '../../theme'
import { Link } from 'gatsby'

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 560px;
  background: #181818;
  min-width: max-content;
  position: relative;
  ${Media.lessThan(Media.small)} {
    height: fit-content;
    left: unset;
  }
`

export const FooterWrap = styled.div`
  width: 1200px;
  margin-top: 40px;
  ${Media.lessThan(Media.small)} {
    width: 100vw;
    margin-top: ${mbSize(60)};
    padding: 0 ${mbSize(40)};
  }
`

export const FooterUpWrap = styled.div`
  display: flex;
  justify-content: space-between;
  ${Media.lessThan(Media.small)} {
    flex-direction: column;
    align-items: center;
  }
`

export const FooterUpLeftWrap = styled.div``

export const FooterLogo = styled(Link)`
  height: fit-content;
  > img {
    width: 234px;
    height: 50px;
    cursor: pointer;
    ${Media.lessThan(Media.small)} {
      width: ${mbSize(374)};
      height: ${mbSize(80)};
    }
  }
`

export const FooterTitle = styled.div`
  font-size: 14px;
  color: #ffffff;
  margin-top: 10px;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(24)};
    margin-top: ${mbSize(10)};
  }
`

export const FacebookWrap = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 280px;
  height: 150px;
  border-radius: 10px;
  margin-top: 22px;
  background: #222222;
  position: relative;
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(30)};
    width: ${mbSize(670)};
    height: ${mbSize(300)};
    border-radius: ${mbSize(20)};
  }
`

export const FacebookScore = styled.img`
  width: 110px;
  height: 36px;
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(220)};
    height: ${mbSize(72)};
  }
`

export const FacebookStar = styled.img`
  width: 140px;
  height: 24px;
  margin-top: 5px;
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(10)};
    width: ${mbSize(280)};
    height: ${mbSize(48)};
  }
`

export const FacebookRoundIcon = styled.img`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 40px;
  height: 40px;
  ${Media.lessThan(Media.small)} {
    top: ${mbSize(24)};
    right: ${mbSize(78)};
    width: ${mbSize(80)};
    height: ${mbSize(80)};
  }
`

export const FacebookTitle = styled.div`
  margin-top: 7px;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(32)};
    margin-top: ${mbSize(14)};
  }
`

export const FacebookDesc = styled.div`
  margin-top: 3px;
  font-size: 12px;
  color: #ffffff;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(24)};
    margin-top: ${mbSize(6)};
  }
`

export const AssociationWrap = styled.div`
  display: flex;
  align-items: center;
  width: 280px;
  height: 80px;
  border-radius: 6px;
  background: #222222;
  margin-top: 20px;
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(30)};
    width: ${mbSize(670)};
    height: ${mbSize(160)};
    border-radius: ${mbSize(12)};
  }
`

export const TNPImg = styled.img`
  width: 109px;
  height: 48px;
  margin: 0 20px 0 10px;
  ${Media.lessThan(Media.small)} {
    margin: 0 ${mbSize(88)} 0 ${mbSize(40)};
    width: ${mbSize(217)};
    height: ${mbSize(96)};
  }
`

export const BlenderImg = styled.img`
  width: 126px;
  height: 46px;
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(262)};
    height: ${mbSize(96)};
  }
`

export const SocialMedia = styled.div`
  margin-top: 20px;
  ${Media.lessThan(Media.small)} {
    display: flex;
    justify-content: center;
    margin-top: ${mbSize(30)};
  }
`

export const LinkIcon = styled.a`
  width: fit-content;
  height: fit-content;
  > svg {
    transition: all 0.3s;
    fill: #dddddd;
    &:hover {
      fill: #f3512b;
    }
  }
  &:nth-child(-n + 4) {
    margin-right: 20px;
  }
`

export const FooterUpCenterWrap = styled.div`
  width: 510px;
  display: flex;
  justify-content: space-between;
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(50)};
    width: 100%;
  }
`

export const LinkListWrap = styled.div<{ $marginTop?: number }>`
  display: flex;
  flex-direction: column;
  margin-top: ${({ $marginTop }) => ($marginTop ? `${$marginTop}px` : 'unset')};
  ${Media.lessThan(Media.small)} {
    margin-top: ${({ $marginTop }) => ($marginTop ? `${mbSize($marginTop)}` : 'unset')};
  }
`

export const LinkListTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(28)};
    margin-bottom: ${mbSize(24)};
  }
`

export const LinkItem = styled.div`
  color: #dddddd;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 5px;
  transition: all 0.3s;
  &:hover {
    color: #fb6244;
  }
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(20)};
    margin-bottom: ${mbSize(16)};
  }
`

export const ContactItem = styled.div`
  color: #dddddd;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 20px;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(20)};
    margin-bottom: ${mbSize(20)};
    line-height: ${mbSize(40)};
  }
`

export const MessageUsIconWrap = styled.div`
  display: flex;
`

export const MessageUsIcon = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #333333;
  transition: all 0.3s;
  > svg {
    fill: #dddddd;
  }
  &:hover {
    background: #f3512b;
    > svg {
      fill: #ffffff;
    }
  }
  &:nth-child(-n + 2) {
    margin-right: 18px;
  }
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(60)};
    height: ${mbSize(60)};
    border-radius: ${mbSize(20)};
    > svg {
      width: ${mbSize(37)};
      height: ${mbSize(36)};
    }
    &:nth-child(-n + 2) {
      margin-right: ${mbSize(16)};
    }
  }
`

export const FooterUpRightWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  height: 360px;
  border-radius: 12px;
  background: #222222;
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(60)};
    width: ${mbSize(670)};
    height: ${mbSize(720)};
    border-radius: ${mbSize(24)};
  }
`

export const NewsletterTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin: 20px 0;
  ${Media.lessThan(Media.small)} {
    margin: ${mbSize(40)} 0;
    font-size: ${mbSize(40)};
  }
`

export const NewsletterDesc = styled.div`
  width: 260px;
  font-size: 14px;
  font-weight: 400;
  color: #999999;
  text-align: center;
  margin-bottom: 30px;
  ${Media.lessThan(Media.small)} {
    margin-bottom: ${mbSize(60)};
    font-size: ${mbSize(24)};
    width: ${mbSize(520)};
  }
`

export const NewsletterForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const NewsletterInput = styled.input<{ $marginBottom?: number }>`
  font-family: MarkPro;
  font-size: 14px;
  width: 260px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #333333;
  outline: none;
  background: #181818;
  color: #fff;
  padding: 0 20px;
  margin-bottom: ${({ $marginBottom }) => ($marginBottom ? `${$marginBottom}px` : 'unset')};
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(24)};
    padding: 0 ${mbSize(40)};
    border-radius: ${mbSize(8)};
    &::placeholder {
      text-align: center;
    }
  }
`

export const NewsletterButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  width: 196px;
  height: 40px;
  border-radius: 20px;
  background: linear-gradient(180deg, #f3512b 0%, #f55c1e 100%);
  margin-top: 40px;
  transition: all 0.3s;
  cursor: pointer;
  &:hover {
    box-shadow: 0px 10px 10px 0px #f3512b4d;
  }
  ${Media.lessThan(Media.small)} {
    width: ${mbSize(392)};
    height: ${mbSize(81)};
    border-radius: ${mbSize(40)};
    margin-top: ${mbSize(80)};
    font-size: ${mbSize(32)};
  }
`

export const FooterDivider = styled.div`
  width: 100%;
  height: 1px;
  background: #444444;
  margin: 45px 0 30px;
  ${Media.lessThan(Media.small)} {
    margin: ${mbSize(66)} 0 ${mbSize(40)};
    height: ${mbSize(2)};
  }
`

export const FooterDownWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666666;
  font-size: 14px;
  ${Media.lessThan(Media.small)} {
    flex-direction: column;
    font-size: ${mbSize(20)};
    margin-bottom: ${mbSize(56)};
  }
`

export const FooterDownLinkWrap = styled.div`
  > a {
    color: #666666;
    &:first-child {
      margin-right: 20px;
    }
  }
  ${Media.lessThan(Media.small)} {
    margin-top: ${mbSize(31)};
  }
`
